module.exports = __webpack_public_path__ + "img/friends.a88c68d2.gif";